import { FacetsType } from "../SearchFilterResultData";
import queryString from "query-string";

type QueryValue = string | string[] | number | null;
type QueryObject = Record<string, QueryValue>;

/**
 * A wrapper around `queryString.stringify` that has comma separated lists and ignores falsy values.
 * @example
 * formatQueryString({searchTerm: 'test', itemIds: [1, 3]}) // 'term=test&itemIds=1,3'
 * formatQueryString({itemIds: [1, null, 3]}) // 'itemIds=1,3'
 * formatQueryString({itemIds: [1, null, '']}) // 'itemIds=1'
 * formatQueryString({itemIds: [null]}) // ''
 */
function formatQueryString(queryObject: QueryObject) {
  return queryString.stringify(queryObject, {
    arrayFormat: "comma",
    skipEmptyString: true,
    skipNull: true,
  });
}

export function getFacetsQueryString(facets: FacetsType = []): string {
  const facetQueryObj: QueryObject = {};

  facets.forEach((facet) => {
    if (!facet.visible) {
      return;
    }

    const facetQueryKey = `f_${facet.name.toLowerCase()}`;
    const checkedItemIds = facet.items.filter((item) => item.selected).map((item) => item.value);

    facetQueryObj[facetQueryKey] = checkedItemIds;
  });

  return formatQueryString(facetQueryObj);
}

export function getSearchQueryString(searchTerm: string): string {
  return formatQueryString({ term: searchTerm });
}

export function getPageNrQueryString(pageNr: number) {
  return pageNr > 1 ? formatQueryString({ page: pageNr }) : "";
}
